import jsonata from "jsonata";

export type ResolutionContext = {
	$index?: number;
};

export type ResolutionResult = {
	value: unknown;
	error?: string;
};

const evaluateExpression = async (params: {
	expression: string;
	data: unknown;
	context?: ResolutionContext;
}): Promise<{ value: unknown; error?: string }> => {
	const { expression, data, context } = params;

	try {
		const expr = jsonata(expression);
		const result = await expr.evaluate(data, context);

		return { value: result };
	} catch (error) {
		const errorMessage = error instanceof Error ? error.message : String(error);
		return {
			value: null,
			error: `JSONata evaluation error: ${errorMessage}`,
		};
	}
};

export const resolveBinding = async (params: {
	binding: DataBinding;
	data: unknown;
	context?: ResolutionContext;
}): Promise<ResolutionResult> => {
	const { binding, data, context } = params;

	if (!binding.path) {
		return {
			value: null,
			error: "Binding path is empty",
		};
	}

	const result = await evaluateExpression({
		expression: binding.path,
		data,
		context,
	});

	if (result.error) {
		return {
			value: null,
			error: result.error,
		};
	}

	return {
		value: result.value,
	};
};
